import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about", label: "About" },
    { path: "/services", label: "Services" },
    { path: "/gallery", label: "Gallery" },
    { path: "/skincare", label: "Skincare" },
    { path: "/vip-membership", label: "VIP" },
    { path: "/contact", label: "Contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header
      data-testid="header"
      className="fixed top-0 w-full z-50 bg-smoke/80 backdrop-blur-md border-b border-matte/5"
    >
      <div className="container mx-auto px-4 md:px-8">
        <nav className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link
            to="/"
            data-testid="logo-link"
            className="flex flex-col"
          >
            <span className="font-serif text-xl md:text-2xl tracking-tight text-matte">
              <span className="font-light">Medical</span>{" "}
              <span className="font-medium">Aesthetic Arts</span>
            </span>
            <span className="text-[10px] text-taupe tracking-wider">aestheticmedicalarts.online</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase().replace(" ", "-")}`}
                className={`nav-link text-xs uppercase tracking-[0.15em] transition-colors duration-200 ${
                  isActive(link.path)
                    ? "text-taupe"
                    : "text-matte hover:text-taupe"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Book Now Button - Desktop */}
          <Link
            to="/contact"
            data-testid="header-book-btn"
            className="hidden lg:block btn-primary"
          >
            Book Now
          </Link>

          {/* Mobile Menu Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X size={24} weight="light" className="text-matte" />
            ) : (
              <List size={24} weight="light" className="text-matte" />
            )}
          </button>
        </nav>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-smoke border-t border-matte/5"
        >
          <div className="container mx-auto px-4 py-8 flex flex-col gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(" ", "-")}`}
                className={`text-sm uppercase tracking-[0.15em] ${
                  isActive(link.path) ? "text-taupe" : "text-matte"
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-book-btn"
              className="btn-primary text-center mt-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              Book Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
